import { ReactNode } from 'react';
import {
  FormControl,
  InputBase,
  Select,
  InputLabel,
  SelectProps,
  FormHelperText,
  MenuItem,
  styled,
  SelectChangeEvent
} from '@mui/material';
import { ControllerRenderProps, FieldValues, useController } from 'react-hook-form';

interface Props extends Omit<SelectProps, 'label'> {
  label: string | ReactNode;
  hookForm?: ControllerRenderProps<FieldValues, string>;
  onChange?: (event: SelectChangeEvent<unknown>) => void;
}

const SpanStyled = styled('span')(({ theme }) => ({
  color: theme.palette.surface[300]
}));

export default function SelectInput({ children, label, hookForm, placeholder, ...props }: Props) {
  const { fieldState } = useController({ name: hookForm?.name ?? '' });

  return (
    <FormControl sx={{ pt: 2, mb: 2 }} fullWidth={props.fullWidth} error={Boolean(fieldState.error?.message)}>
      <InputLabel shrink htmlFor={props.name}>
        {label}
      </InputLabel>
      <Select
        id={props.name}
        sx={{ py: 1, ...props.sx }}
        input={<InputBase />}
        displayEmpty
        renderValue={(selected) => {
          if (!selected) {
            return <SpanStyled>{placeholder}</SpanStyled>;
          }
          return selected;
        }}
        {...props}
        {...hookForm}
        onChange={(e) => {
          hookForm?.onChange(e.target.value);
          props.onChange?.(e);
        }}
      >
        <MenuItem disabled value="">
          <em>{placeholder}</em>
        </MenuItem>
        {children}
      </Select>
      <FormHelperText sx={{ m: 0 }}>{fieldState.error?.message}</FormHelperText>
    </FormControl>
  );
}
